"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'socialMediaPlan.step.brief': 'Brief',
    'socialMediaPlan.step.preview': 'AI Preview',
    'socialMediaPlan.step.schedule': 'Schedule',
};
